import { render, staticRenderFns } from "./PushNotificationRedirect.vue?vue&type=template&id=1fd150b1&scoped=true&"
import script from "./PushNotificationRedirect.vue?vue&type=script&lang=js&"
export * from "./PushNotificationRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd150b1",
  null
  
)

export default component.exports